// extracted by mini-css-extract-plugin
export var form = "index-module--form--ZP8ds";
export var hitsWrapper = "index-module--hitsWrapper--lI0Ft";
export var inputContainer = "index-module--inputContainer--U9wKF";
export var inputWrapper = "index-module--inputWrapper--aSvPZ";
export var searchContainer = "index-module--searchContainer--6l1Ep";